export default __webpack_public_path__ + "static/media/Star.2d43182b.svg";